/**
 * 认证相关API接口
 * 登录、注册、获取用户信息等
 */
import request from './request';
import { USE_MOCK } from './config';
/**
 * 用户登录
 */
export async function login(data) {
    if (USE_MOCK) {
        return {
            token: 'mock-token',
            user: {
                id: 1,
                username: 'admin',
                nickname: '管理员',
                email: 'admin@example.com',
                role: 'admin',
                permissions: ['*']
            }
        };
    }
    return request.post('/auth/login', data);
}
/**
 * 用户注册
 */
export async function register(data) {
    if (USE_MOCK) {
        return;
    }
    return request.post('/auth/register', data);
}
/**
 * 获取当前用户信息
 */
export async function getCurrentUser() {
    if (USE_MOCK) {
        return {
            id: 1,
            username: 'admin',
            nickname: '管理员',
            email: 'admin@example.com',
            role: 'admin',
            permissions: ['*']
        };
    }
    return request.get('/auth/me');
}
/**
 * 用户退出登录
 */
export async function logout(userId, token) {
    if (USE_MOCK) {
        return;
    }
    return request.post('/auth/logout', null, { params: { userId, token } });
}
